module.exports = __webpack_public_path__ + "img/shopping-list.c0a42aae.svg";